 <h3>My Tasks</h3>
  <div *ngFor="let task of projectTasks" class="card">
     
    <div class="card-content">
      
 <table><tr>
  <td style="text-align: left;"><a mat-fab class="custom-fab" (click)="removeTaskfromProject(task)"><mat-icon>delete</mat-icon></a> </td>
  <td style="text-align: right;"> <a mat-fab class="custom-fab" (click)="editRow(task)"><mat-icon>edit</mat-icon></a></td>
</tr></table>
      

      <div class="card-row">
        <span class="card-label"><b>Title:</b></span>
        <span class="card-value">{{ task.title}}</span>
      </div>
      <div class="card-row"> 
          <span class="card-label"><b>Date:</b></span>
          
        <span class="card-value">{{ task.dueDate | date }}</span>
        
      </div>
        <div class="card-row">
        <span class="card-label"><b>Assigned To:</b></span>
          
        <span class="card-value">{{ task.assignedTo }} </span>
        </div>
         
      <!-- </div>
      <div class="card-row"> -->
        <!-- <span class="card-label"><b>Qty:</b></span>
        <span class="card-value">{{ material.qty }}</span> -->
      </div>
      <ng-template #editCell>
     
        
        <input [(ngModel)]="task.title" title="save" />
           <input [(ngModel)]="task.title" title="save" (blur)="saveEdit(task)" />
          
           <button mat-icon-button (click)="cancelEdit(task)">
          <mat-icon>done</mat-icon>
        </button>
  
      </ng-template> 
    </div> 
   



 